module.exports = __webpack_public_path__ + "img/fengge_grey.c213b936.svg";